import { Component, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { CartsService } from 'projects/cart-tv/src/app/data/cart.sevice';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { Part } from '../../data/parts/part';

@Component({
  selector: 'app-cart-cabinet-edit-dialog',
  templateUrl: './cart-cabinet-edit-dialog.component.html',
  styleUrls: ['./cart-cabinet-edit-dialog.component.scss']
})
export class CartCabinetEditDialogComponent implements OnInit, OnDestroy {
  cabs: Cabinet[] = [];
  selectedCabs: Cabinet[] = []

  parts: Part[] = [];
  selectedParts: Part[] = []

  searchString: string;

  cabIdsSet = new Set<number>();

  loadingSpinner = false;
  emptyLoadingSpinner = false;


  optionLabel: string;
  objNum: string;

  cartNumber: number
  trayNumber: string

  constructor(
    private cartsService: CartsService,
    protected dialogRef: MatDialogRef<CartCabinetEditDialogComponent>,
    protected dialog: MatDialog,
    private miscSnackBarService: MiscSnackBarService,
    protected el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: {
      allCabs: Cabinet[],
      cartId: number,
      trayId: number,
      trayNumber: string,
      selectedIdsSet: Set<number>
    }
  ) {
    this.cabIdsSet = data.selectedIdsSet;
    this.cabs = data.allCabs

    this.cartNumber = data.cartId
    this.trayNumber = data.trayNumber

    this.optionLabel = 'cabinetName'
    this.objNum = 'cabinetId'

    if(this.cabs) {
      this.cabs.forEach(cab => {
        cab.showName = `#${cab.cabinetId} ${cab.cabinetName}`
      })
    }
  }

  ngOnInit(): void {
    this.getParts();

    if(this.cabIdsSet) {
      this.selectedCabs = this.cabs.filter(cab => this.cabIdsSet.has(cab.cabinetId));

      const highlighted = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-highlight');
      if(highlighted) {
        timer(1).subscribe(emit => {
          if(highlighted[0]) {
            highlighted[0].scrollIntoView({block: 'center', behavior: 'auto'})
          }
        })
      }
    }
  }

  getParts() {
    this.cartsService.getPartsForCart(this.cartNumber, this.data.trayId).subscribe(parts => {
      this.parts = parts;
      // this.selectedParts = this.parts.filter(part => this.cabIdsSet.has(part.cabinetId));
    })
  }

  request() {
    const ids = this.selectedCabs ? this.selectedCabs.map(cab => cab.id) : []
    this.cartsService.saveTray(this.data.cartId, this.data.trayId, ids).subscribe(res => {
      this.dialogRef.close(res);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.loadingSpinner = false;
      this.emptyLoadingSpinner = false;
    })
  }

  save() {
    this.loadingSpinner = true;
    this.request()
  }

  empty() {
    this.emptyLoadingSpinner = true;
    this.selectedCabs = null
    this.request()
  }


  closeDialog() {
    this.dialogRef.close('close-button');
  }

  ngOnDestroy() {

  }

}
